







































































































































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store'
import PackageCard from '@/components/packages/PackageCard.vue'
import JsonFetchAlert from '@/components/common/JsonFetchAlert.vue'
import SimpleTile from '@/components/common/SimpleTile.vue'
import PackagesTable from '@/components/packages/PackagesTable.vue'
import * as helper from '@/assets/_js/helpers'
import TileMap from '@/components/common/TileMap.vue'
import { Accountext, Package } from 'dapp-client'
import AccountsTable from '@/components/accounts/AccountsTable.vue'
import TileSocial from '@/components/common/TileSocial.vue'
const numeral = require('numeral')

@Component({
  components: {
    PackageCard,
    PackagesTable,
    JsonFetchAlert,
    SimpleTile,
    TileMap,
    AccountsTable,
    TileSocial
  }
})
export default class PrvDetails extends Vue {
  @Prop() private provider!: string
  private numeral = numeral
  private pkgJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }
  private dspJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }

  get prvDetails() {
    return vxm.dappservices.packageTable.find(
      (pkg: Package) => pkg.provider === this.provider && pkg.package_json_uri
    )
  }

  get totalStaked() {
    let total = 0
    for (const prv of vxm.dappservices.dspRanking) {
      total += prv.balance
    }
    return total
  }

  get prvUsers() {
    return vxm.dappservices.accountTable.filter(
      (user: Accountext) => user.provider === this.provider
    )
  }

  get dspNumbers() {
    let res = vxm.dappservices.dspRanking.find(
      (prv: any) => prv.provider === this.provider
    )
    if (res) return res
    else return { balance: 0, packages: 0 }
  }

  get filteredPkgs() {
    const allPkgs = vxm.dappservices.packageTable
    let results = allPkgs.filter((pkg: any) => pkg.provider === this.provider)
    return results
  }

  get getNameLogo() {
    return helper.nameLogo(this.provider, this.pkgJson, this.dspJson)
  }

  get location() {
    if (!this.dspJson.error) {
      return {
        lat: this.dspJson.data.location.latitude,
        long: this.dspJson.data.location.longitude
      }
    } else return { lat: 0, long: 0 }
  }

  get tableView() {
    return vxm.core.tableView
  }

  set tableView(value) {
    vxm.core.setTableView(value)
  }

  async loadData() {
    if (this.prvDetails) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.prvDetails)
      let dspJson = await vxm.jsondb.getDspJson(this.prvDetails)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }

  @Watch('prvDetails')
  async onPrvChange(val: any, oldVal: any) {
    await this.loadData()
  }

  // Lifecycle hooks
  created() {}

  async mounted() {
    await this.loadData()
  }

  updated() {}

  destroyed() {}
}
